import { useFlags } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Card, Icon, Image, Message, Popup, Segment } from "semantic-ui-react";
import { onBannerDismiss } from "../../../libs/component_utils";
import { walmartMXTranslations as t } from "../../../translations/walmartMXTranslations";
import useCanAccessRetailAttribution from "../../common/hooks/useCanAccessRetailAttribution";
import REPORT_TYPES from "../fixtures/report-types";

const ReportIndexPage = ({ history }) => {
  const intl = useIntl();
  const showErrorMessage = history.location.state?.action === "error";
  const {
    whitelabelNewToBrand,
    whitelabelOfflineAttribution,
    whitelabelAudienceSegmentReport,
    whitelabelBrandLiftCampaign,
  } = useFlags();
  const canAccessRetailAttribution = useCanAccessRetailAttribution();
  const slugGates = {
    "new-to-brand": whitelabelNewToBrand,
    "omnichannel-attribution": whitelabelOfflineAttribution,
    audience: whitelabelAudienceSegmentReport,
    "retail-attribution": canAccessRetailAttribution,
    "brand-lift": whitelabelBrandLiftCampaign,
  };

  return (
    <Segment
      basic
      style={{ padding: "0" }}
    >
      {showErrorMessage && (
        <Message
          error
          className="page-success-message"
          attached
          onDismiss={onBannerDismiss}
        >
          {history.location.state?.msg}
        </Message>
      )}

      <h1>
        {intl.formatMessage({
          id: "HEADING_REPORTS",
          defaultMessage: "Reports",
        })}
      </h1>
      <Card.Group itemsPerRow={4}>
        {Object.entries(REPORT_TYPES).map(([slug, { title, messageId, coverSrc }]) => {
          if (slug in slugGates && !slugGates[slug]) return null;
          return (
            <ReportCard
              key={slug}
              href={`/report/${slug}`}
              title={title}
              messageId={messageId}
              coverSrc={coverSrc}
              tooltip={slug === "brand-lift" ? t.brandLiftReportCardTooltip : null}
            />
          );
        })}
      </Card.Group>
    </Segment>
  );
};

const ReportCard = ({ href, title, messageId, coverSrc, tooltip }) => {
  const intl = useIntl();
  return (
    <Card
      as={Link}
      to={href}
    >
      <Image
        src={coverSrc}
        wrapped
        ui={false}
      />
      <Card.Content>
        <Card.Header>
          {intl.formatMessage({
            id: messageId,
            defaultMessage: title,
          })}
          {tooltip && (
            <Popup
              content={tooltip}
              inverted
              size="mini"
              trigger={
                <Icon
                  name="info circle"
                  className="cursor-help"
                  style={{ marginLeft: "0.4em", fontSize: "0.9em" }}
                  onClick={(e) => e.preventDefault()}
                />
              }
            />
          )}
        </Card.Header>
      </Card.Content>
    </Card>
  );
};

ReportCard.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  coverSrc: PropTypes.string,
  tooltip: PropTypes.string,
};

export default ReportIndexPage;
